import React from "react";
import ReactDOM from "react-dom";
import { Link } from "react-router-dom";

const DeleteModal = ({ Name, onDelete }) => {
  const modal = (
    <>
      {/* Delete Performance Indicator Modal */}
      <div className="modal custom-modal fade" id="delete" role="dialog">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              <div className="form-header">
                <h3>{Name}</h3>
                <p>Are you sure want to delete?</p>
              </div>
              <div className="modal-btn delete-action">
                <div className="row">
                  <div className="col-6">
                  <button
                    type="button"
                    className="btn btn-primary continue-btn"
                    onClick={onDelete}
                    data-bs-dismiss="modal"
                  >
                    Delete
                  </button>
                  </div>
                  <div className="col-6">
                  <button
                    type="button"
                    className="btn btn-primary cancel-btn"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Delete Performance Indicator Modal */}
    </>
  );
  if (typeof document !== "undefined" && document.body) {
    return ReactDOM.createPortal(modal, document.body);
  }
  return modal;
};

export default DeleteModal;
